import { useEffect, useState } from "react";
import { fetchPublicOrders, getMid, searchOrders } from "../utils/api";
import { MdOutlineArrowBack } from "react-icons/md";
import OrderBox from "./OrderBox";
import OrderDetailsPage from "./OrderDetailsPage";
import { format, parseISO } from "date-fns";
import Footer from "../Footer/Footer";
import SearchBox from "./SearchBox";

function OrdersPage({
  setOrderListActive,
  settings,
  phone,
  email,
  orderList,
  setOrderList,
  ordersLoader,
  setOrdersLoader,
  orderDetails,
  orderDetailsActive,
  setOrderDetails,
  setOrderDetailsActive,
  encryptedMid,
  setEncryptedMid,
  customerName,
  setOtpSent,
  setOtpVerified,
  setPhone,
  setEmail,
  accessToken,
}) {
  const [searchingOrder, setSearchingOrder] = useState(false);
  const [searchOrderName, setSearchOrderName] = useState("");

  useEffect(() => {
    if (orderList && orderList !== null && orderList.length > 0) {
      if (encryptedMid == null) {
        getMid(settings).then((resp) => {
          setEncryptedMid(resp.data.encrypted_mid);
          orderList.forEach((order) => {
            order.exchange_eligible = false;
            order.refund_eligible = false;
            if (order.eligible) {
              order.order_items.every((item) => {
                if (item.exchange_eligible) {
                  order.exchange_eligible = true;
                }
              });
              order.order_items.every((item) => {
                if (item.refund_eligible) {
                  order.refund_eligible = true;
                }
              });
            }

            if (order.exchange_eligible || order.refund_eligible) {
              if (phone && phone !== null) {
                order.return_exchange_url = `${settings.rms_host}/orders?encipherencode=${resp.data.encrypted_mid}&oid=${order.order_id}&cs=true&p=${phone}&sw=true&access_token=${accessToken}`;
              }
              if (email && email !== null) {
                order.return_exchange_url = `${settings.rms_host}/orders?encipherencode=${resp.data.encrypted_mid}&oid=${order.order_id}&cs=true&e=${email}&sw=true&access_token=${accessToken}`;
              }
            } else order.return_exchange_url = "";
          });
          setOrderList(orderList);
        });
      } else {
        orderList.forEach((order) => {
          order.exchange_eligible = false;
          order.refund_eligible = false;
          if (order.eligible) {
            order.order_items.every((item) => {
              if (item.exchange_eligible) {
                order.exchange_eligible = true;
              }
            });
            order.order_items.every((item) => {
              if (item.refund_eligible) {
                order.refund_eligible = true;
              }
            });
          }

          if (order.exchange_eligible || order.refund_eligible) {
            if (phone && phone !== null) {
              order.return_exchange_url = `${settings.rms_host}/orders?encipherencode=${encryptedMid}&oid=${order.order_id}&cs=true&p=${phone}&sw=true&access_token=${accessToken}`;
            }
            if (email && email !== null) {
              order.return_exchange_url = `${settings.rms_host}/orders?encipherencode=${encryptedMid}&oid=${order.order_id}&cs=true&e=${email}&sw=true&access_token=${accessToken}`;
            }
          } else order.return_exchange_url = "";
        });
        setOrderList(orderList);
      }
    }
  }, [orderList]);

  const searchOrder = () => {
    setSearchingOrder(true);
    if (
      settings?.merchant?.public_api_key &&
      settings.merchant.public_api_key !== ""
    ) {
      fetchPublicOrders(settings, phone, email, searchOrderName)
        .then((resp) => {
          setOrderList(resp.data.orders);
        })
        .finally(() => {
          setSearchingOrder(false);
        });
    } else {
      searchOrders(settings, email, phone, accessToken, searchOrderName)
        .then((resp) => {
          setOrderList(resp.data.orders);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setSearchingOrder(false);
        });
    }
  };

  return (
    <div
      className="bg-neutral-100 flex flex-col"
      style={{ height: "calc(100vh - 140px)" }}
    >
      {orderDetailsActive ? (
        <>
          <div
            className="w-full flex items-center px-4 py-5 h-16 text-white"
            style={{ background: settings["--site-widget-primary-color"] }}
          >
            <div
              className="flex items-center"
              onClick={() => {
                setOrderDetailsActive(false);
              }}
            >
              <MdOutlineArrowBack className="cursor-pointer" />
              <p className="ml-2 fw-medium text-sm cursor-pointer">
                <span className="block">
                  Order {orderDetails.order_number}
                </span>
                <span className="block text-xs mt-0.5 text-[#F2F2F2]">
                  {format(
                    parseISO(orderDetails.order_created_at),
                    "dd MMM yyyy"
                  )}
                </span>
              </p>
            </div>
            <div
              className="max-w-[120px] absolute"
              style={{ transform: "translateX(-50%)", left: "50%" }}
            >
              <img
                src={settings.logo_url}
                className="w-auto text-center ml-5 max-h-12"
                alt={settings.merchant.storename}
              />
            </div>
          </div>
          <div className="flex-1 overflow-auto">
            <div className="p-5">
              {ordersLoader ? (
                <div className="site-widget-loader"></div>
              ) : (
                <OrderDetailsPage
                  orderDetails={orderDetails}
                  settings={settings}
                />
              )}
            </div>
            {settings.is_pragma_branding_visible && (
              <Footer settings={settings} help={true} />
            )}
          </div>
        </>
      ) : (
        <>
          <div
            className="w-full rounded-b-xl px-5 pt-5 pb-4 text-white"
            style={{ background: settings["--site-widget-primary-color"] }}
          >
            <div className="flex items-center">
              <div
                className="flex items-center"
                onClick={() => setOrderListActive(false)}
              >
                <MdOutlineArrowBack className="cursor-pointer" />
                <p className="ml-2 fw-medium text-sm cursor-pointer">
                  Track Order
                </p>
              </div>
              <div
                className="max-w-[120px] absolute"
                style={{ transform: "translateX(-50%)", left: "50%" }}
              >
                <img
                  src={settings.logo_url}
                  className="w-auto text-center ml-5 max-h-12"
                  alt={settings.merchant.storename}
                />
              </div>
            </div>
            <p className="mt-4 text-sm">Hey {customerName} 👋</p>
            <p className="text-xs mt-1">Manage your orders here</p>
            <SearchBox
              searchOrderName={searchOrderName}
              setSearchOrderName={setSearchOrderName}
              searchOrder={searchOrder}
            />
          </div>
          <div className="flex-1 overflow-auto">
            <div className="px-5 pt-3 pb-5">
              {searchingOrder || ordersLoader ? (
                <div className="site-widget-loader"></div>
              ) : orderList && orderList !== null && orderList.length > 0 ? (
                orderList.map((order) => {
                  return (
                    <OrderBox
                      order={order}
                      setOrdersLoader={setOrdersLoader}
                      settings={settings}
                      setOrderDetailsActive={setOrderDetailsActive}
                      setOrderDetails={setOrderDetails}
                      key={order.order_id}
                    />
                  );
                })
              ) : (
                <div className="text-xs text-center">
                  <img src="/noorders.svg" alt="" className="mx-auto my-5" />
                  <p className="text-[#2B3446] font-bold my-2 text-base">
                    No orders yet
                  </p>
                  <p className="text-[#151F32]">
                    It seems you haven't placed any orders yet
                  </p>
                  <p className="text-[#9B9FA7] mt-5">OR</p>
                  <p
                    className="my-5 font-bold cursor-pointer"
                    style={{ color: settings["--site-widget-primary-color"] }}
                    onClick={() => {
                      setOrderListActive(false);
                      setOtpVerified(false);
                      setOtpSent(false);
                      setPhone(null);
                      setEmail(null);
                      let iframe = document.getElementById("sessionIframe");
                      iframe.contentWindow.postMessage(
                        { phone: null, email: null, topic: "PRAGMA" },
                        "*"
                      );
                    }}
                  >
                    Change number/email
                  </p>
                  <p className="text-[#9B9FA7]">OR</p>
                  <p
                    className="my-5 font-bold cursor-pointer"
                    style={{ color: settings["--site-widget-primary-color"] }}
                    onClick={() => {
                      setOrderListActive(false);
                    }}
                  >
                    Back
                  </p>
                </div>
              )}
            </div>
            {settings.is_pragma_branding_visible && (
              <Footer settings={settings} help={true} />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default OrdersPage;
